import { FC, Fragment, useEffect, useState } from 'react';

import { IconWarningTriangle } from '@robocorp/icons/iconic';
import { withSnackbar, WithSnackbarProps } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { useCurrentWorkspace } from '../queries';

type State = { snackbarKey?: string };
type Props = State & WithSnackbarProps;

const WorkspaceActivityChecker: FC<Props> = ({ addSnackbar, closeSnackbar }) => {
  const [snackbarKey, setSnackbarKey] = useState('');
  const { t } = useTranslation();

  const { data: currentWorkspace } = useCurrentWorkspace();

  useEffect(() => {
    if (currentWorkspace?.state === 'disabled' && !snackbarKey) {
      const key = addSnackbar({
        message: t('workspaceDisabledSnack', { name: currentWorkspace.name }),
        icon: IconWarningTriangle,
        variant: 'danger',
        persist: true,
        unique: true,
        close: true,
      });

      setSnackbarKey(key);
    }
    if (currentWorkspace?.state !== 'disabled' && snackbarKey) {
      closeSnackbar(snackbarKey);
      setSnackbarKey('');
    }
  }, [currentWorkspace?.state]);

  return currentWorkspace ? <Fragment /> : null;
};

export default withSnackbar(WorkspaceActivityChecker);
